// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics, Analytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

// Your web app's Firebase configuration for diffusion-cad
const firebaseConfig = {
  apiKey: "AIzaSyBE7evgXelXYcdcXEYS0E7qi2yMhmGhT30",
  authDomain: "diffusion-cad.firebaseapp.com",
  projectId: "diffusion-cad",
  storageBucket: "diffusion-cad.firebasestorage.app",
  messagingSenderId: "747051292146",
  appId: "1:747051292146:web:9efee08e800a3ce60c876b",
  measurementId: "G-SX325547NJ",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics (only in browser environment)
let analytics: Analytics | null = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

export { analytics };
export default app;